import { CUSTOMER_ID } from 'const/local-storage';

const getCustomerId = async (mapper: string): Promise<string | undefined> => {
  try {
    const map = new Function(mapper);
    const customerId = (await map()) as string;
    localStorage.setItem(CUSTOMER_ID, customerId);
    return customerId;
  } catch (e) {
    console.error(`failed to execute getCustomerId mapper error: ${(e as Error).message}`);
  }
};
export default getCustomerId;
